import React from "react";
import { createPortal } from "react-dom";
import "./style.scss";

const Tooltip = ({ title, image, position }) => {
  const tooltipStyle = position
    ? {
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: "translate(-50%, -15%)",
      }
    : {};

  const tooltipElement = (
    <div className="interactive-map-tooltip" style={tooltipStyle}>
      <div className="interactive-map-tooltip-title">{title}</div>
      <div className="interactive-map-tooltip-image">
        <img src={image} alt={title} />
      </div>
    </div>
  );

  return createPortal(tooltipElement, document.body);
};

export default Tooltip;
